<div *ngIf="isVisible" class="driver-list-details-container left-second-level-container" [@openClose]>

  <div *ngIf="isLoading" class="h-full grid place-items-center">
    <div class="flex flex-col justify-center align-middle">
      <div class="flex justify-center items-center">
        <mat-spinner [strokeWidth]="2" [diameter]="40" color="primary"></mat-spinner>
      </div>
      <span class="mt-2">{{'labels.loading-data' | translate}}</span>
    </div>
  </div>

  <div *ngIf="!isLoading" class="data-loaded">
    <wm-driver-details-header class="header" [driver]="driver"></wm-driver-details-header>
    <wm-driver-details-tabs class="tabs" [driver]="driver"></wm-driver-details-tabs>
  </div>

</div>
